module.exports = __webpack_public_path__ + "static/jeff-bronson-lg-8d00c578f6c0ebd41a81d0f81b2099b5.png";